import type { StockRuntimeItem } from "../gateway/local-projection-client";
import type { StockTransferRuntimeProjection } from "../gateway/stock-transfer-client";
import { indexedScope } from "./indexed-runtime";
import { posRuntimeDb } from "./pos-db";
import type { TrustedTerminalIdentity } from "./terminal-state";

function projectionKey(identity: TrustedTerminalIdentity) {
  return `stock-transfer-runtime:${indexedScope(identity, "stock-transfer")}`;
}

export async function applyStockTransferRuntime(
  identity: TrustedTerminalIdentity,
  payload: StockTransferRuntimeProjection,
) {
  const scopeKey = indexedScope(identity, "stock-transfer");
  const now = new Date().toISOString();
  await posRuntimeDb.projections.put({
    key: projectionKey(identity),
    scopeKey,
    domain: "STOCK_TRANSFER",
    revision: payload.projection_revision || "STOCK_TRANSFER_V1",
    payload,
    updatedAt: now,
  });
}

export async function readStockTransferRuntime(identity: TrustedTerminalIdentity) {
  const row = await posRuntimeDb.projections.get(projectionKey(identity));
  if (!row?.payload || typeof row.payload !== "object") return null;
  return row.payload as StockTransferRuntimeProjection;
}

export async function readStockTransferLocalItems(identity: TrustedTerminalIdentity) {
  const scopeKey = indexedScope(identity, "stock");
  const rows = await posRuntimeDb.stockRuntime
    .where("scopeKey")
    .equals(scopeKey)
    .and((row) => row.active)
    .toArray();
  return rows.flatMap((row) => (
    row.payload && typeof row.payload === "object"
      ? [row.payload as StockRuntimeItem]
      : []
  ));
}

export async function purgeStockTransferRuntimeOutsideScope(identity: TrustedTerminalIdentity) {
  const keepScope = indexedScope(identity, "stock-transfer");
  await posRuntimeDb.projections
    .where("domain")
    .equals("STOCK_TRANSFER")
    .and((row) => row.scopeKey !== keepScope)
    .delete();
}
